const MONTH = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/** "2026-09" -> "September 2026" (month picker label). */
export function formatMonthLabel(month: string): string {
  const match = /^(\d{4})-(\d{2})$/.exec(month);
  if (!match) return month;
  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1;
  const name = MONTH[monthIndex] ?? match[2];
  return `${name} ${year}`;
}

/** The current month as "YYYY-MM" — the API's own default when no `month` is given. */
export function currentMonth(now: Date = new Date()): string {
  return `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, "0")}`;
}

/** The last `count` months up to and including `month`, most recent first. */
export function recentMonths(month: string, count = 12): string[] {
  const match = /^(\d{4})-(\d{2})$/.exec(month);
  if (!match) return [month];
  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1;
  const out: string[] = [];
  for (let i = 0; i < count; i += 1) {
    const d = new Date(Date.UTC(year, monthIndex - i, 1));
    out.push(`${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`);
  }
  return out;
}
